import React from 'react';
import { useSelector } from 'react-redux';
import { decode } from 'js-base64';
import { selectRulesText } from 'store/pageModel';
import { StyledSection } from './styles';

export const RulesTemplate = () => {
	const text = useSelector(selectRulesText);

	if (!text) {
		return null;
	}

	return (
		<StyledSection
			dangerouslySetInnerHTML={{ __html: decode(text) }}
			data-qa={'rules-template'}
		/>
	);
};
